import React from 'react';
import { Box } from '@wix/design-system';
import { InfoLine } from '../InfoSection';
export const Amount = ({ amount, dataHook, formatMoney, title, type, weight, ...rest }) => {
    const styleProps = type === 'heading' ? { type } : { weight };
    const renderTitle = () => (React.createElement(InfoLine, { flex: 1, ...styleProps, dataHook: `${dataHook}.title` }, title));
    const renderAmount = () => (React.createElement(InfoLine, { ...styleProps, dataHook: `${dataHook}.amount` }, formatMoney(amount)));
    return (React.createElement(Box, { ...rest, dataHook: dataHook },
        renderTitle(),
        renderAmount()));
};
//# sourceMappingURL=Amount.js.map